import { render, staticRenderFns } from "./MonthlyTargets.vue?vue&type=template&id=0b59879b&"
import script from "./MonthlyTargets.vue?vue&type=script&lang=js&"
export * from "./MonthlyTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports